var InFlight = InFlight || {};

InFlight.eventSearch = (function() {
    var _departmentSelectId = "departmentSelect";
    var _iconPath = "/assets/images/departments/";
    var _departmentDict;
    var _departments = [
    {
        id:"ALL",
        name:"All"
    },
    {
        id: "EXT",
        name: "Non-City Departments (Public/Private Opportunities)"
    },
    {
        id: "311",
        name: "311 Customer Service Center"
    },
    {
        id: "SCI",
        name: "Academy of Sciences"
    },
    {
        id: "ADM",
        name: "Administrative Services"
    },
    {
        id: "ADP",
        name: "Adult Probation"
    },
    {
        id: "AIR",
        name: "Airport Commission"
    },
    {
        id: "ANC",
        name: "Animal Care and Control"
    },
    {
        id: "ART",
        name: "Art Commission"
    },
    {
        id: "AAM",
        name: "Asian Art Museum"
    },
    {
        id: "ASR",
        name: "Assessor"
    },
    {
        id: "BOA",
        name: "Board of Appeals"
    },
    {
        id: "BOS",
        name: "Board of Supervisors"
    },
    {
        id: "DBI",
        name: "Building Inspection"
    },
    {
        id: "CSS",
        name: "Child Support Services"
    },
    {
        id: "CFC",
        name: "Children and Families Commission"
    },
    {
        id: "CHF",
        name: "Children Youth and Families"
    },
    {
        id: "CAT",
        name: "City Attorney"
    },
    {
        id: "CPC",
        name: "City Planning"
    },
    {
        id: "CSC",
        name: "Civil Service Commission"
    },
    {
        id: "CCD",
        name: "Community College District"
    },
    {
        id: "HCN",
        name: "Community Health Network"
    },
    {
        id: "CII",
        name: "Community Investment and Infrastructure"
    },
    {
        id: "CON",
        name: "Controller"
    },
    {
        id: "CFM",
        name: "Convention Facilities"
    },
    {
        id: "CTA",
        name: "County Transportation Authority"
    },
    {
        id: "AGW",
        name: "Department of Consumer Assurance"
    },
    {
        id: "DAS",
        name: "Department of Disability and Aging Services"
    },
    {
        id: "DEC",
        name: "Department of Early Childhood"
    },
    {
        id: "DEM",
        name: "Department of Emergency Management"
    },
    {
        id: "HOM",
        name: "Department of Homelessness"
    },
    {
        id: "HRD",
        name: "Department of Human Resources"
    },
    {
        id: "DPA",
        name: "Department of Police Accountability"
    },
    {
        id: "DPH",
        name: "Department of Public Health"
    },
    {
        id: "HCH",
        name: "Department of Public Health - Central Office"
    },
    {
        id: "HMH",
        name: "Department of Public Health - Mental Health"
    },
    {
        id: "TIS",
        name: "Department of Technology"
    },
    {
        id: "WOM",
        name: "Department on the Status of Women"
    },
    {
        id: "DAT",
        name: "District Attorney"
    },
    {
        id: "ECN",
        name: "Economic and Workforce Development"
    },
    {
        id: "ENV",
        name: "Environment"
    },
    {
        id: "ETH",
        name: "Ethics Commission"
    },
    {
        id: "FVA",
        name: "Film and Video Arts"
    },
    {
        id: "FAM",
        name: "Fine Arts Museum"
    },
    {
        id: "FIR",
        name: "Fire Department"
    },
    {
        id: "GEN",
        name: "General City Responsibility"
    },
    {
        id: "GSA",
        name: "General Services Agency"
    },
    {
        id: "HSS",
        name: "Health Service System"
    },
    {
        id: "HRC",
        name: "Human Rights Commission"
    },
    {
        id: "HSA",
        name: "Human Services Agency"
    },
    {
        id: "JUV",
        name: "Juvenile Probation Department"
    },
    {
        id: "HLH",
        name: "Laguna Honda Hospital"
    },
    {
        id: "LLB",
        name: "Law Library"
    },
    {
        id: "LHP",
        name: "Light Heat and Power"
    },
    {
        id: "MYR",
        name: "Mayor"
    },
    {
        id: "MOH",
        name: "Mayor's Office of Housing"
    },
    {
        id: "CME",
        name: "Medical Examiner"
    },
    {
        id: "DPT",
        name: "Municipal Railway"
    },
    {
        id: "MTA",
        name: "Municipal Transportation Agency"
    },
    {
        id: "OCC",
        name: "Office of Citizen Complaints"
    },
    {
        id: "OCA",
        name: "Office of Contract Administration"
    },
    {
        id: "PTC",
        name: "Parking and Traffic Commission"
    },
    {
        id: "POL",
        name: "Police"
    },
    {
        id: "PRT",
        name: "Port"
    },
    {
        id: "PAG",
        name: "Public Administration and Guardian"
    },
    {
        id: "PDR",
        name: "Public Defender"
    },
    {
        id: "LIB",
        name: "Public Library"
    },
    {
        id: "PUC",
        name: "Public Utilities Commission"
    },
    {
        id: "DPW",
        name: "Public Works"
    },
    {
        id: "PUR",
        name: "Purchasing"
    },
    {
        id: "RED",
        name: "Real Estate Division"
    },
    {
        id: "RCD",
        name: "Recorder's Office"
    },
    {
        id: "REC",
        name: "Recreation and Park Commission"
    },
    {
        id: "RDA",
        name: "Redevelopment Agency"
    },
    {
        id: "REG",
        name: "Registrar"
    },
    {
        id: "RNT",
        name: "Rent Arbitration Board"
    },
    {
        id: "RET",
        name: "Retirement Services"
    },
    {
        id: "HGH",
        name: "San Francisco General Hospital"
    },
    {
        id: "SHF",
        name: "Sheriff"
    },
    {
        id: "MCT",
        name: "Superior Court"
    },
    {
        id: "TXC",
        name: "Taxi Commission"
    },
    {
        id: "TTX",
        name: "Treasurer and Tax Collector"
    },
    {
        id: "TID",
        name: "Treasure Island Development Authority"
    },
    {
        id: "CRT",
        name: "Trial Courts"
    },
    {
        id: "USD",
        name: "Unified School District"
    },
    {
        id: "WAR",
        name: "War Memorial"
    }];    

    var _getIconPathFromEventTitle = function (title) {
        var depID = "EXT";
        if (title.length >= 3) {
            depID = title.substr(0, 3);
        }
        if (_departmentExists(depID)) {
            return _iconPath+"icon-"+depID+".svg";
        }
        return _iconPath+"icon-EXT.svg";
    };

    var _departmentExists = function(department) {
        if (!_departmentDict) {
            _prepareDepartmentDictionary();
        }

        if (_departmentDict[department]) {
            return true;
        } else {
            return false;
        }
    };

    var _prepareDepartmentDictionary = function() {
        _departmentDict = {};
        $.each(_departments, function (index, item) {
            _departmentDict[item.id] = item.name;
        });        
    }

    var _createDepartmentSelect = function () {
        var count = _departments.length;

        var select = $('<select/>', {
            id: _departmentSelectId,
            class: 'form-control'
        });
        for (var i = 0; i < count; i++) {
            var department = _departments[i];
            $('<option/>', {
                val: department.id,
                text: department.name
            }).appendTo(select);
        }

        return select;
    };

    var _getDepartmentSelect = function () {
        return $('[id='+_departmentSelectId+']');
    };

    var _addDepartmentSelect = function ($container) {        
        var $currentSelect = _getDepartmentSelect();
        if ($container && !$currentSelect.length) {
            var $select = _createDepartmentSelect();
            $container.append($select);
        }        
    };

    var _getProcessedSearchValue = function(search) {
        var $department = _getDepartmentSelect();
        var trimmedSearch = search.trim();
        var dep = $department.val();
        if (dep != '' && dep != 'ALL') {
            // department abbreviation plus space character (wrapped in PS wildcard)
            var depSearch = '%'+dep+' %';
            if (trimmedSearch.length > 0) {
                depSearch += '%'+trimmedSearch+'%';
            }
            return depSearch;            
        } else {
            var nonDepSearch = trimmedSearch.replace(/%/g, "");
            return nonDepSearch;
        }        
    }

    var _getDepartmentFromSearchValue = function (search) {
        var regExp = /^%(.{3})%/gm;
        var match = regExp.exec(search);
        if (match && match.length === 2) {
            return match[1];
        };
        return undefined;
    };

    var _getCleanSearchValue = function (search) {
        if (search.indexOf('%') >= 0) {
            var regExp = /^%(?:.{4})%(?:%(.*)%)?$/gm;
            var match = regExp.exec(search);        
            if (match && match.length === 2) {
                return match[1];
            } else {
                return "";
            };
        }
        return search;        
    };

    var _setDepartmentSelectFromSearchValue = function (search) {
        var dep = _getDepartmentFromSearchValue(search);
        if (dep) {
            var $select = _getDepartmentSelect();
            $select.val(dep);
        }
    };

    return {
        getIconPathFromEventTitle: _getIconPathFromEventTitle,
        getProcessedSearchValue: _getProcessedSearchValue,
        setDepartmentFromSearchValue: _setDepartmentSelectFromSearchValue,
        addDepartmentSelect: _addDepartmentSelect,
        getDepartmentSelect: _getDepartmentSelect,
        getCleanSearchValue: _getCleanSearchValue
    };
})();
